import RecordStore from '../../stores/RecordStore';
import CallStore from '../../stores/CallStore';
import './index.css';
import { observer } from 'mobx-react';
import { useContext, useEffect } from 'react';
import { notRecordingIcon, recordingIcon } from '../../assets';
import { ModalAlertContext } from '../../contexts/ModalAlertContext';
import strings from '../../localization';


const TechCallRecording = ({ remoteVideoTrack }) => {

  const { showModalAlert, closeModalAlert, showPleaseWait, closePleaseWait } = useContext(ModalAlertContext);


  const isRecording = RecordStore.isRecording;

  const handleStartRecording = async () => {
    try {
      showPleaseWait({ title: strings.pleaseWait, message: "", customStyle: { alignItems: 'center' }, customContentStyle: { width: 400 } });
      const resp = await RecordStore.startRecording(CallStore.slug);
      closePleaseWait();
      if (resp.success) {
        RecordStore.setIsRecording(true);
        RecordStore.setRecord(resp.data);
      } else {
        showModalAlert({
          title: strings.error,
          message: resp.message,
          type: 'error',
          confirmText: strings.ok,
          position: 'vertical',
          onCancel: null,
          onConfirm: async () => {
            closeModalAlert();
          }
        });
      }
    } catch (error) {
      closePleaseWait();
      showModalAlert({
        title: strings.error,
        message: error.message,
        type: 'error',
        confirmText: strings.ok,
        position: 'vertical',
        onCancel: null,
        onConfirm: async () => {
          closeModalAlert();
        }
      });
    }
  }

  const handleStopRecording = async () => {
    try {

      showPleaseWait({ title: strings.pleaseWait, message: "", customStyle: { alignItems: 'center' }, customContentStyle: { width: 400 } });
      const resp = await RecordStore.stopRecording(CallStore.slug, RecordStore.record.recordingId);
      closePleaseWait();
      if (resp.success) {
      } else {
        showModalAlert({
          title: strings.error,
          message: resp.message,
          type: 'error',
          confirmText: strings.ok,
          position: 'vertical',
          onCancel: null,
          onConfirm: async () => {
            closeModalAlert();
          }
        });
      }
    } catch (error) {
      closePleaseWait();
      showModalAlert({
        title: strings.error,
        message: error.message,
        type: 'error',
        confirmText: strings.ok,
        position: 'vertical',
        onCancel: null,
        onConfirm: async () => {
          closeModalAlert();
        }
      });
    }
  }

  const startAutoRecording = () => {
    const remoteVideoTrackReady = remoteVideoTrack ? true : false;
    if (remoteVideoTrackReady) {
      console.log("🚀 ~ startAutoRecording ~ remoteVideoTrackReady:", remoteVideoTrackReady);
      handleStartRecording();
    } else {
      console.log("🚀 ~ startAutoRecording ~ remoteVideoTrackReady:", remoteVideoTrackReady);
    }
  }

  useEffect(() => {

    const getRecordingStatus = async () => {
      if (!CallStore.slug) {
        return;
      }
      const resp = await RecordStore.getCallRecordingStatus(CallStore.slug);
      if (!resp) {
        return;
      }
      if (resp.success) {
        if (resp.data.hasActiveRecording) {
          RecordStore.setIsRecording(true);
          RecordStore.setRecord(resp.data.activeRecording);
        } else {
          RecordStore.setIsRecording(false);
          startAutoRecording();
        }
      } else {
        showModalAlert({
          title: strings.error,
          message: resp.message,
          type: 'error',
          confirmText: strings.ok,
          position: 'vertical',
          onCancel: null,
          onConfirm: async () => {
            closeModalAlert();
          }
        });
      }
    }
    getRecordingStatus();

  }, [CallStore.slug, remoteVideoTrack]);

  return (
    <div className="tech-call-recording">
      {!isRecording && (
        <button className="" onClick={handleStartRecording}>
          <img src={notRecordingIcon} alt="not-recording" />
          <span>{strings.startVideoRecording}</span>
        </button>
      )}
      {isRecording && (
        <button className="" onClick={handleStopRecording}>
          <img src={recordingIcon} alt="recording" />
          <span>{strings.stopVideoRecording}</span>
        </button>
      )}
    </div>
  );
}

export default observer(TechCallRecording);